import { KeyboardEvent, KeyboardEventHandler } from 'react';

export interface IUseKeyPressProps {
  onEnter?: (event: KeyboardEvent) => void;
  onArrowLeft?: (event: KeyboardEvent) => void;
  onArrowRight?: (event: KeyboardEvent) => void;
  onDelete?: (event: KeyboardEvent) => void;
  onBackspace?: (event: KeyboardEvent) => void;
  onTab?: (event: KeyboardEvent) => void;
  onEscape?: (event: KeyboardEvent) => void;
  onArrowUp?: (event: KeyboardEvent) => void;
  onArrowDown?: (event: KeyboardEvent) => void;
  onPageUp?: (event: KeyboardEvent) => void;
  onPageDown?: (event: KeyboardEvent) => void;
  onHome?: (event: KeyboardEvent) => void;
  onEnd?: (event: KeyboardEvent) => void;
  onKeyPress?: (event: KeyboardEvent) => void;
}

export interface IUseKeyPress {
  handleKeyPress: (event: KeyboardEvent) => void;
}

export const useKeyPress = (props: IUseKeyPressProps): IUseKeyPress => {
  const keyPressedMapper = {
    Enter: props.onEnter,
    ArrowLeft: props.onArrowLeft,
    ArrowRight: props.onArrowRight,
    Delete: props.onDelete,
    Backspace: props.onBackspace,
    Tab: props.onTab,
    Escape: props.onEscape,
    ArrowUp: props.onArrowUp,
    ArrowDown: props.onArrowDown,
    PageUp: props.onPageUp,
    PageDown: props.onPageDown,
    Home: props.onHome,
    End: props.onEnd,
  };

  const handleKeyPress: KeyboardEventHandler = (event: KeyboardEvent): void => {
    if (event.key in keyPressedMapper) {
      const handler =
        keyPressedMapper[event.key as keyof typeof keyPressedMapper];
      handler?.(event);
    }
    props.onKeyPress?.(event);
  };

  return { handleKeyPress };
};
